import axiosInstance from "../axiosInterceptor";

export async function updateHomeworkHelpQuestion(questionId, body) {
  const response = await axiosInstance.put(
    `student/homeworkHelp/updateQuestion/${questionId}`,
    body
  );
  const data = response?.data;
  return data;
}
